// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonLayout from './../../components/CommonLayout';
import FaqItem from './../../components/FaqItem/FaqItem';

import FAQ_DATA from './FaqData.json';
import Styles from './faqs.module.scss';

export default function Faqs() {
    const { t } = useTranslation(['translation', 'faqTranslation']);
    return <FrequentlyAskedQuestions pageTitle={t('faqs')} faqs={t('frequently_asked_questions')} />;
}

export function FrequentlyAskedQuestions({ pageTitle, faqs }: { pageTitle: string, faqs: any }) {
    return (
        <section>
            <div className={Styles.faqs}>
                <CommonLayout pageTitle={[pageTitle]}>
                    <div className={Styles.bodyContainer}>
                        <div className={Styles.title}>{faqs}</div>

                        {
                            FAQ_DATA.map((faq: any) => <FaqItem faq={faq} key={faq.key} />)
                        }
                    </div>
                </CommonLayout>
            </div>
        </section>
    );
}

